import { useTranslation } from 'react-i18next'

import { FailedIcon } from '@arcade/web/icons/react'
import { ArcadePageHeader, Button, IconMat, spacing, Stack } from '@cash-design-system/react'

const goToSupport = () => {
  window.open('/support', '_blank')
}

export const ModalErrorContent = () => {
  const { t } = useTranslation()

  return (
    <Stack space={spacing.xxl}>
      <ArcadePageHeader
        asset={{
          avatar: (
            <IconMat variant="danger">
              <FailedIcon size={32} />
            </IconMat>
          ),
        }}
        title={t('Something went wrong', { context: 'modal title' })}
        titleElement="h1"
        body={t('Try again or contact support.', { context: 'modal body text' })}
      />
      <Button variant="secondary" type="button" onClick={goToSupport}>
        {t('Contact Support', { context: 'button text' })}
      </Button>
    </Stack>
  )
}
